<script lang="ts">
    import Heading from '@/components/Heading.svelte';
    import { Button } from '@/components/ui/button';
    import { Separator } from '@/components/ui/separator';
    import { cn } from '@/lib/utils';
    import { Link, page } from '@inertiajs/svelte';
    import type { Snippet } from 'svelte';
    import { Kanban, BookOpen, Hammer, Calendar, Users, Smartphone } from 'lucide-svelte';

    interface Guide {
        slug: string;
        title: string;
        description: string;
        icon: string;
    }

    interface Props {
        guides: Guide[];
        children?: Snippet;
    }

    let { guides, children }: Props = $props();

    const currentPath = $page.props.ziggy?.location ? new URL($page.props.ziggy.location).pathname : '';

    const getIcon = (icon: string) => {
        switch (icon) {
            case 'kanban':
                return Kanban;
            case 'hammer':
                return Hammer;
            case 'calendar':
                return Calendar;
            case 'users':
                return Users;
            case 'smartphone':
                return Smartphone;
            default:
                return BookOpen;
        }
    };
</script>

<div class="px-4 py-4">
    <Heading title="Guides" description="Learn how to use the portal features" />

    <div class="flex flex-col lg:flex-row lg:space-x-12">
        <aside class="w-full max-w-xl lg:w-56">
            <nav class="flex flex-col space-x-0 space-y-1">
                {#each guides as guide (guide.slug)}
                    {@const Icon = getIcon(guide.icon)}
                    <Link href={route('guides.show', { slug: guide.slug })}>
                        <Button
                            variant="ghost"
                            class={cn('w-full justify-start', {
                                'bg-muted': currentPath === `/guides/${guide.slug}`,
                            })}
                        >
                            <Icon class="mr-2 h-4 w-4" />
                            {guide.title.replace(' User Guide', '')}
                        </Button>
                    </Link>
                {/each}
            </nav>
        </aside>

        <Separator class="my-4 lg:hidden" />

        <div class="flex-1">
            <section class="max-w-4xl">
                {@render children?.()}
            </section>
        </div>
    </div>
</div>